import {gql} from '@apollo/client';

import {doQuerySafe} from 'graphql-client/ApolloWrappers';
import {BenchlingQueryResult, useBenchlingQuery} from 'graphql-client/BenchlingQuery';
import {getFragmentWrapper} from 'graphql-client/declarative-translations/external/getFragmentWrapper';

import {TagSchemasWithRegistryQuery} from './__generated/TagSchemasWithRegistryQuery';

export const TAG_SCHEMAS_WITH_REGISTRY_QUERY = gql`
  query TagSchemasWithRegistryQuery @skipAudit @engComponent(name: INVENTORY) {
    tagSchemas {
      ...TagSchemaGraphQL
      registry {
        ...RegistryGraphQL
      }
    }
  }
  ${getFragmentWrapper('TagSchema').fragment}
  ${getFragmentWrapper('Registry').fragment}
`;

export function useTagSchemasWithRegistryQuery(): BenchlingQueryResult<TagSchemasWithRegistryQuery> {
  return useBenchlingQuery<TagSchemasWithRegistryQuery>(TAG_SCHEMAS_WITH_REGISTRY_QUERY);
}

export function doTagSchemasWithRegistryQuery(): Promise<TagSchemasWithRegistryQuery> {
  return doQuerySafe<TagSchemasWithRegistryQuery, {}>({query: TAG_SCHEMAS_WITH_REGISTRY_QUERY});
}
